// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_13W7j22eVd","forgotPasswordForm":"_2x87bhLC3S","input":"_2MQ3ZPDGjM","label":"_1mGgjxp1lH","loginButton":"_335sseyfTc"};